import { ApiService, GenericError} from './api-main'
import TokenService from './token-service'
import store from '../store'

const BeneficiaryService = {
    getBeneficiaryList: async function() {
        const url = 'main/beneficiary'

        try {
            await ApiService.generateAuthClient();
            const response = await ApiService.get(url, {})
            // console.log(response)
            return ApiService.validateResponse(response, '0404')
        } catch(e) {
            console.log(e)
            if(e instanceof GenericError) {
                throw e
            }
            return false;
        }
    },

    getCountryDetails: async function() {
        const url = 'main/country/' + store.state.misc.appBranchId

        try {
            await ApiService.generateAuthClient();
            const response = await ApiService.get(url, {})
            // console.log(response)
            return ApiService.validateResponse(response, '1038')
        } catch(e) {
            console.log(e)
            if(e instanceof GenericError) {
                throw e
            }
            return false;
        }
    },

    getCountryList: async function() {
        const url = 'main/country/list/' + store.state.misc.appBranchId

        try {
            await ApiService.generateAuthClient();
            const response = await ApiService.get(url, {})
            // console.log(response)
            return ApiService.validateResponse(response, '1009')
        } catch(e) {
            console.log(e)
            if(e instanceof GenericError) {
                throw e
            }
            return false;
        }
    },

    // DR-1845 - Beneficiary Country / Town-City: whether the field is mandatory.
    // addressHardMandatory      = global toggle (opssystemconfiguration BENEFICIARY_ADDRESS_MANDATORY)
    // isCountryAddressMandatory = per-country flag (only meaningful when countryId > 0)
    getBeneficiaryAddressConfig: async function(countryId) {
        const url = 'main/beneficiary/addressconfig'
        const params = { countryId: countryId }

        try {
            await ApiService.generateAuthClient();
            const response = await ApiService.get(url, {params})
            return ApiService.validateResponse(response, '5550')
        } catch(e) {
            // DR-1845 code-inspection fix (Minor) - removed console.log(e); the
            // exception is already correctly re-thrown/handled below.
            if(e instanceof GenericError) {
                throw e
            }
            return false;
        }
    },

    getTransactionTypeList: async function(countryId) {
        const url = 'main/transactiontype'
        const params = {
            countryId: countryId,
            rbId     : store.state.misc.appBranchId
        }

        try {
            await ApiService.generateAuthClient();
            const response = await ApiService.get(url, {params})
            // console.log(response)
            return ApiService.validateResponse(response, '1043')
        } catch(e) {
            console.log(e)
            if(e instanceof GenericError) {
                throw e
            }
            return false;
        }
    },

    getRetailBranchDetails: async function() {
        const url = 'main/retail/branch/' + store.state.misc.appBranchId

        try {
            await ApiService.generateAuthClient();
            const response = await ApiService.get(url, {})
            // console.log(response)
            return ApiService.validateResponse(response, '1041')
        } catch(e) {
            console.log(e)
            if(e instanceof GenericError) {
                throw e
            }
            return false;
        }
    },

    getBankList: async function(raId, countryId, ttId) {
        const url = 'main/beneficiarybank/list'
        const params = {
            retailAgentId    : raId,
            countryId        : countryId,
            transactionTypeId: ttId
        }

        try {
            await ApiService.generateAuthClient();
            const response = await ApiService.get(url, {params})
            // console.log(response)
            return ApiService.validateResponse(response, '1021')
        } catch(e) {
            console.log(e)
            if(e instanceof GenericError) {
                throw e
            }
            return false;
        }
    },

    getBankBranchList: async function(bankId) {
        const url = 'main/bankbranch/bank/' + bankId
        const params = {
            langCode: "en"
        }

        try {
            await ApiService.generateAuthClient();
            const response = await ApiService.get(url, {params})
            // console.log(response)
            return ApiService.validateResponse(response, '1028')
        } catch(e) {
            console.log(e)
            if(e instanceof GenericError) {
                throw e
            }
            return false;
        }
    },

    searchIFSC: async function(countryId, bankId, ifscCode) {
        const url = 'main/bank/ifsc'
        const params = {
            countryId : countryId,
            bankId    : bankId,
            ifsc      : ifscCode
        }

        try {
            await ApiService.generateAuthClient();
            const response = await ApiService.get(url, {params})
            // console.log(response)
            return ApiService.validateResponse(response, '3600')
        } catch(e) {
            console.log(e)
            if(e instanceof GenericError) {
                throw e
            }
            return false;
        }
    },

    getCollectionAgentList: async function(raId, countryId) {
        const url = 'main/colagent/retailagent/' + raId + '/country/' + countryId

        try {
            await ApiService.generateAuthClient();
            const response = await ApiService.get(url, {})
            // console.log(response)
            return ApiService.validateResponse(response, '1013')
        } catch(e) {
            console.log(e)
            if(e instanceof GenericError) {
                throw e
            }
            return false;
        }
    },

    getCollectionPointList: async function(colAgentId) {
        const url = 'main/colpoint/colagent/' + colAgentId

        try {
            await ApiService.generateAuthClient();
            const response = await ApiService.get(url, {})
            // console.log(response)
            return ApiService.validateResponse(response, '1015')
        } catch(e) {
            console.log(e)
            if(e instanceof GenericError) {
                throw e
            }
            return false;
        }
    },

    getProvinceList: async function(countryId) {
        const url = 'main/province/' + countryId

        try {
            await ApiService.generateAuthClient();
            const response = await ApiService.get(url, {})
            // console.log(response)
            return ApiService.validateResponse(response, '1017')
        } catch(e) {
            console.log(e)
            if(e instanceof GenericError) {
                throw e
            }
            return false;
        }
    },

    getCityList: async function(countryId, provinceId) {
        const url = 'main/city/' + countryId + '/' + provinceId

        try {
            await ApiService.generateAuthClient();
            const response = await ApiService.get(url, {})
            // console.log(response)
            return ApiService.validateResponse(response, '1019')
        } catch(e) {
            console.log(e)
            if(e instanceof GenericError) {
                throw e
            }
            return false;
        }
    },

    getCityByPostcode: async function(postcode, countryId) {
        const url = 'main/city/postcode'
        const params = {
            postcode : postcode,
            countryId: countryId
        }

        try {
            await ApiService.generateAuthClient();
            const response = await ApiService.get(url, {params})
            // console.log(response)
            return ApiService.validateResponse(response, '1019')
        } catch(e) {
            console.log(e)
            if(e instanceof GenericError) {
                throw e
            }
            return false;
        }
    },

    getStreetListByCity: async function(cityId) {
        const url = 'main/city/street/' + cityId

        try {
            await ApiService.generateAuthClient();
            const response = await ApiService.get(url, {})
            //console.log("Street List : ", response)
            return ApiService.validateResponse(response, '0440')
        } catch(e) {
            console.log(e)
            if(e instanceof GenericError) {
                throw e
            }
            return false;
        }
    },

    getPostCodeByStreetId: async function(streetId) {
        const url = 'main/city/postcode/' + streetId

        try {
            await ApiService.generateAuthClient();
            const response = await ApiService.get(url, {})
            //console.log("Postcode : ", response)
            return ApiService.validateResponse(response, '0442')
        } catch(e) {
            console.log(e)
            if(e instanceof GenericError) {
                throw e
            }
            return false;
        }
    },

    getCityById: async function(cityId) {
        const url = 'main/city/' + cityId

        try {
            await ApiService.generateAuthClient();
            const response = await ApiService.get(url, {})
            // console.log(response)
            return ApiService.validateResponse(response, '1019')
        } catch(e) {
            console.log(e)
            if(e instanceof GenericError) {
                throw e
            }
            return false;
        }
    },

    getPaymentPurposeList: async function(countryId, gender, beneficiaryTypeId) {
        const url = 'main/paymentpurpose/country/' + countryId+"/"+gender+"/"+beneficiaryTypeId

        try {
            await ApiService.generateAuthClient();
            const response = await ApiService.get(url, {})
            // console.log(response)
            return ApiService.validateResponse(response, '1026')
        } catch(e) {
            console.log(e)
            if(e instanceof GenericError) {
                throw e
            }
            return false;
        }
    },

    getBillCorporationList: async function(countryId) {
        const url = 'main/billcorp/country/' + countryId

        try {
            await ApiService.generateAuthClient();
            const response = await ApiService.get(url, {})
            // console.log(response)
            return ApiService.validateResponse(response, '1023')
        } catch(e) {
            console.log(e)
            if(e instanceof GenericError) {
                throw e
            }
            return false;
        }
    },

    getBillCorporationListByName: async function(billCorpName) {
        const params = {
            countryId     : store.state.beneficiary.homeCountryId,
            billCorpName  : billCorpName
        }
        //console.log("getBillCorporationListByName params : "+store.state.beneficiary.homeCountryId+" ## "+billCorpName)

        const url = 'main/billcorp/search'


        try {
            await ApiService.generateAuthClient();
            const response = await ApiService.get(url, {params})
            //console.log(response)
            return ApiService.validateResponse(response, '1031')
        } catch(e) {
            console.log(e)
            if(e instanceof GenericError) {
                throw e
            }
            return false;
        }
    },

    getBillCorporationDetails: async function(billCorpId) {
        const url = 'main/billcorp/' + billCorpId

        try {
            await ApiService.generateAuthClient();
            const response = await ApiService.get(url, {})
            // console.log(response)
            return ApiService.validateResponse(response, '1044')
        } catch(e) {
            console.log(e)
            if(e instanceof GenericError) {
                throw e
            }
            return false;
        }
    },

    getCountryPhoneCodeList: async function() {
        const url = 'main/country/list/idd'

        try{
            await ApiService.generateAuthClient();
            const response = await ApiService.get(url, {})
            // console.log(response)
            return ApiService.validateResponse(response, '1046')
        } catch(e) {
            console.log(e)
            if(e instanceof GenericError) {
                throw e
            }
            return false;
        }
    },

    getPhilGovMemberTypeList: async function() {
        const url = 'main/philgov/membertype'

        try {
            await ApiService.generateAuthClient();
            const response = await ApiService.get(url, {})
            // console.log(response)
            return ApiService.validateResponse(response, '11330')
        } catch(e) {
            console.log(e)
            if(e instanceof GenericError) {
                throw e
            }
            return false;
        }
    },

    getBeneficiaryIdType: async function() {
        const url = 'main/idtype/beneficiary'

        try {
            await ApiService.generateAuthClient();
            const response = await ApiService.get(url, {})
            // console.log(response)
            return ApiService.validateResponse(response, '1032')
        } catch(e) {
            console.log(e)
            if(e instanceof GenericError) {
                throw e
            }
            return false;
        }
    },

    getBeneficiaryDetail: async function(beneficiaryId) {
        const params = {
            beneficiaryId     : beneficiaryId
        }
        const url = 'main/beneficiary/detail/'

        try {
            await ApiService.generateAuthClient();
            const response = await ApiService.get(url, {params})
            // console.log(response)
            return ApiService.validateResponse(response, '0406')
        } catch(e) {
            console.log(e)
            if(e instanceof GenericError) {
                throw e
            }
            return false;
        }
    },

    createBeneficiary: async function(beneficiaryData) {
        let resBeneficiary = {invalid:false };
        ApiService.setHeader()

        let axiosHeader = {
            headers: {
                'Content-Type'                : 'application/json;charset=UTF-8',
                "Access-Control-Allow-Origin" : '*',
                "Authorization"               : `Bearer ${TokenService.getToken()}`,
                //"P2H-CustomerId"              : ApiService.getFormData("p2hCustomerId"),
            }
        }

        let bankBranch = "";
        let pp         = (beneficiaryData.paymentPurposeId == -1)
                        ? beneficiaryData.paymentPurposeOther
                        : beneficiaryData.paymentPurpose;
        let idType     = (beneficiaryData.transactionTypeId == 3
                            && (beneficiaryData.homeCountryId == 18 || beneficiaryData.homeCountryId == 98 || beneficiaryData.homeCountryId == 197))
                        ? beneficiaryData.idTypeSelect
                        : beneficiaryData.identificationType;

        const isWallet = beneficiaryData.transactionTypeId == 102 ? true : false
        let accountNumber = beneficiaryData.bankAccountNo == undefined ? "" : beneficiaryData.bankAccountNo
        if(isWallet){
            if(beneficiaryData.homeCountryId == 167){ // exclude countryIDD for PH (DR-1438)
                accountNumber = beneficiaryData.walletNo == undefined ? "" : beneficiaryData.walletNo
            }else{
                accountNumber = beneficiaryData.walletNo == undefined ? "" : beneficiaryData.homeCountryIdd.substring(1) + beneficiaryData.walletNo
            }
        }

        // 1 - BANK TRANSFER
        if(beneficiaryData.transactionTypeId == 1) {
            switch(beneficiaryData.homeCountryId) {
                case 13: // 13 - AUSTRALIA
                case 152: // 152 - NEW ZEALAND
                    bankBranch = beneficiaryData.bsbCode; break;
                case 238: // 238 - EUROPEAN UNION (EU)
                case 253: // 253 - AMERICA
                    bankBranch = beneficiaryData.swiftCode; break;
                case 98: // 98 - INDIA
                    bankBranch = beneficiaryData.ifscCode; break;
                case 221: // 221 - UNITED KINGDOM
                    bankBranch = beneficiaryData.sortCode; break;
                default:
                    bankBranch = beneficiaryData.bankBranch; break;
            }
        }

        // console.log("BillPayment: " + beneficiaryData.transactionTypeId == 4)
        // console.log("BankTransfer: " + beneficiaryData.transactionTypeId == 1)
        // console.log("Collection: " + beneficiaryData.transactionTypeId == 3)

        const param = {
            destinationCountryId     : beneficiaryData.homeCountryId,
            originatingCountryId     : beneficiaryData.hostCountryId,
            transactionTypeId        : beneficiaryData.transactionTypeId,
            deliveryMethodId         : 0,
            bankAccountName          : encodeURIComponent(beneficiaryData.beneficiaryName),
            firstName                : encodeURIComponent(beneficiaryData.beneficiaryName),
            displayName              : encodeURIComponent(beneficiaryData.nickname),
            identificationType       : encodeURIComponent(idType),
            identificationNo         : encodeURIComponent(beneficiaryData.identificationNo),
            beneficiaryTypeId        : beneficiaryData.beneficiaryTypeId,
            bankId                   : beneficiaryData.transactionTypeId == 4 ? beneficiaryData.billCorporationId : beneficiaryData.bankId,
            bankBranch               : bankBranch,
            bankBranchId             : beneficiaryData.bankBranchId,
            iban                     : beneficiaryData.iban,
            collectionAgentId        : beneficiaryData.collectionAgentId,
            collectionPointId        : beneficiaryData.collectionPointId,
            provinceId               : beneficiaryData.provinceId,
            cityId                   : beneficiaryData.cityId,
            address                  : encodeURIComponent(beneficiaryData.street),
            postCode                 : beneficiaryData.postcode,
            locatingNote             : encodeURIComponent(beneficiaryData.locatingNote),
            landmark                 : encodeURIComponent(beneficiaryData.landmark),
            bankAccountNo            : accountNumber,
            dateOfBirth              : encodeURIComponent(beneficiaryData.dateOfBirth),
            philGovMemberTypeId      : beneficiaryData.philGovMemberTypeId,
            referenceNo              : encodeURIComponent(beneficiaryData.refNo),
            audAbn                   : beneficiaryData.audAbn,
            audAcn                   : beneficiaryData.audAcn,
            nzbn                     : beneficiaryData.nzbn,
            beneficiaryCountryId     : beneficiaryData.beneficiaryCountryId,
            beneficiaryTownCity      : encodeURIComponent(beneficiaryData.beneficiaryTownCity == undefined ? "" : beneficiaryData.beneficiaryTownCity),
            paymentPurpose           : encodeURIComponent(pp),
            homePhone                : beneficiaryData.homeNo,
            homePhoneCountryId       : beneficiaryData.homeIDD,
            mobilePhone              : beneficiaryData.mobileNo,
            mobilePhoneCountryId     : beneficiaryData.mobileIDD,
            smsNotification          : false,
            email                    : encodeURIComponent(beneficiaryData.email),
            emailNotification        : false,
            validateCreateBeneficiary: false,
            bankNotes                : "",
            test                     : false
        }

        const url = 'main/beneficiary/create'

        try {
            await ApiService.generateAuthClient();
            const response = await ApiService.customHeader(url, param, axiosHeader)
            // console.log(response)
            resBeneficiary = response.data;

            return resBeneficiary;
        } catch(e) {
            // console.log(e)
            resBeneficiary.invalid = true;
            if(e.response.data.status == '90008') { // Access token has expired
                resBeneficiary.message = "otp-invalid-text-8"
            }
            return resBeneficiary;
        }
    },

    validateBeneInput: async function(beneficiaryData, isCreateBeneficiary) {
        let validateInput = {invalid:false };
        ApiService.setHeader()

        let axiosHeader = {
            headers: {
                'Content-Type'                : 'application/json;charset=UTF-8',
                "Access-Control-Allow-Origin" : '*',
                "Authorization"               : `Bearer ${TokenService.getToken()}`,
                //"P2H-CustomerId"              : ApiService.getFormData("p2hCustomerId"),
            }
        };

        // TRANSACTION TYPE = 4 || DELIVERY METHOD = 0 - BILL PAYMENT
        let isBillPayment = (isCreateBeneficiary && beneficiaryData.transactionTypeId == 4)
                            ? true
                            : (!isCreateBeneficiary && beneficiaryData.deliveryMethodId == 0 ? true : false)

        // TRANSACTION TYPE = 1 || DELIVERY METHOD = 1 - BANK TRANSFER
        let isBankTransfer = (isCreateBeneficiary && beneficiaryData.transactionTypeId == 1)
                            ? true
                            : (!isCreateBeneficiary && beneficiaryData.deliveryMethodId == 1 ? true : false)

        // TRANSACTION TYPE = 3 || DELIVERY METHOD = 3 - COLLECTION
        let isCollection = (isCreateBeneficiary && beneficiaryData.transactionTypeId == 3)
                            ? true
                            : (!isCreateBeneficiary && beneficiaryData.deliveryMethodId == 3 ? true : false)

        const isPhilGov = parseInt(beneficiaryData.bankId) == 4520 || parseInt(beneficiaryData.bankId) == 4521 || parseInt(beneficiaryData.bankId) == 4522;
        const isWallet = (isCreateBeneficiary && !isPhilGov && beneficiaryData.transactionTypeId == 102)
                         ? true
                         : (!isCreateBeneficiary && !isPhilGov && (beneficiaryData.bankTypeId == 2 &&  beneficiaryData.deliveryMethodId == 1) ?  true : false)
        let accountNumber = beneficiaryData.bankAccountNo == undefined ? "" : beneficiaryData.bankAccountNo
        if(isWallet){
            if(beneficiaryData.homeCountryId == 167){ // exclude countryIDD for PH (DR-1438)
                accountNumber = beneficiaryData.walletNo == undefined ? "" : beneficiaryData.walletNo
            }else{
                accountNumber = beneficiaryData.walletNo == undefined ? "" : beneficiaryData.homeCountryIdd.substring(1) + beneficiaryData.walletNo
            }
        }

        // console.log("isBillPayment: " + isBillPayment)
        // console.log("isBankTransfer: " + isBankTransfer)
        // console.log("isCollection: " + isCollection)

        let bankBranch = "";
        let pp         = (beneficiaryData.paymentPurposeId == -1)
                        ? beneficiaryData.paymentPurposeOther
                        : beneficiaryData.paymentPurpose;
        let idType     = (isCollection && (beneficiaryData.homeCountryId == 18 || beneficiaryData.homeCountryId == 98 || beneficiaryData.homeCountryId == 197))
                        ? beneficiaryData.idTypeSelect
                        : beneficiaryData.identificationType;

        if(isBankTransfer) {
            switch(beneficiaryData.homeCountryId) {
                case 13: // 13 - AUSTRALIA
                case 152: // 152 - NEW ZEALAND
                    bankBranch = beneficiaryData.bsbCode; break;
                case 238: // 238 - EUROPEAN UNION (EU)
                case 253: // 253 - AMERICA
                    bankBranch = beneficiaryData.swiftCode; break;
                case 98: // 98 - INDIA
                    bankBranch = isCreateBeneficiary ? beneficiaryData.ifscCode : beneficiaryData.ifscCode.substring(0, 11); break;
                case 221: // 221 - UNITED KINGDOM
                    bankBranch = beneficiaryData.sortCode; break;
                default:
                    bankBranch = beneficiaryData.bankBranch; break;
            }
        }

        const param = {
            destinationCountryId     : parseInt(beneficiaryData.homeCountryId),
            originatingCountryId     : parseInt(beneficiaryData.hostCountryId),
            transactionTypeId        : parseInt(beneficiaryData.transactionTypeId),
            deliveryMethodId         : parseInt(beneficiaryData.deliveryMethodId),
            bankAccountName          : encodeURIComponent(beneficiaryData.beneficiaryName == undefined ? "" : beneficiaryData.beneficiaryName),
            firstName                : encodeURIComponent(beneficiaryData.beneficiaryName == undefined ? "" : beneficiaryData.beneficiaryName),
            displayName              : encodeURIComponent(beneficiaryData.nickname == undefined ? "" : beneficiaryData.nickname),
            identificationType       : encodeURIComponent((idType == undefined || idType == "") ? "" : idType),
            identificationNo         : encodeURIComponent(beneficiaryData.identificationNo == undefined ? "" : beneficiaryData.identificationNo),
            beneficiaryTypeId        : parseInt(beneficiaryData.beneficiaryTypeId),
            bankId                   : isBillPayment ? parseInt(beneficiaryData.billCorporationId) : parseInt(beneficiaryData.bankId),
            bankBranch               : (bankBranch == undefined || bankBranch == "") ? "" : bankBranch,
            bankBranchId             : parseInt(beneficiaryData.bankBranchId),
            iban                     : beneficiaryData.iban == undefined ? "" : beneficiaryData.iban,
            collectionAgentId        : parseInt(beneficiaryData.collectionAgentId),
            collectionPointId        : parseInt(beneficiaryData.collectionPointId),
            provinceId               : parseInt(beneficiaryData.provinceId),
            cityId                   : parseInt(beneficiaryData.cityId),
            address                  : encodeURIComponent(beneficiaryData.street == undefined ? "" : beneficiaryData.street),
            postCode                 : beneficiaryData.postcode == undefined ? "" : beneficiaryData.postcode,
            locatingNote             : encodeURIComponent(beneficiaryData.locatingNote == undefined ? "" : beneficiaryData.locatingNote),
            landmark                 : encodeURIComponent(beneficiaryData.landmark == undefined ? "" : beneficiaryData.landmark),
            bankAccountNo            : accountNumber,//beneficiaryData.bankAccountNo == undefined ? "" : beneficiaryData.bankAccountNo,
            dateOfBirth              : encodeURIComponent(beneficiaryData.dateOfBirth == undefined ? "" : beneficiaryData.dateOfBirth),
            philGovMemberTypeId      : parseInt(beneficiaryData.philGovMemberTypeId),
            referenceNo              : encodeURIComponent(beneficiaryData.refNo == undefined ? "" : beneficiaryData.refNo),
            audAbn                   : beneficiaryData.audAbn == undefined ? "" : beneficiaryData.audAbn,
            audAcn                   : beneficiaryData.audAcn == undefined ? "" : beneficiaryData.audAcn,
            nzbn                     : beneficiaryData.nzbn == undefined ? "" : beneficiaryData.nzbn,
            beneficiaryCountryId     : beneficiaryData.beneficiaryCountryId == undefined ? 0 : parseInt(beneficiaryData.beneficiaryCountryId),
            beneficiaryTownCity      : encodeURIComponent(beneficiaryData.beneficiaryTownCity == undefined ? "" : beneficiaryData.beneficiaryTownCity),
            paymentPurpose           : encodeURIComponent(pp == undefined ? "" : pp),
            homePhone                : beneficiaryData.homeNo == undefined ? "" : beneficiaryData.homeNo,
            homePhoneCountryId       : beneficiaryData.homeIDD == undefined ? 0 : parseInt(beneficiaryData.homeIDD),
            mobilePhone              : beneficiaryData.mobileNo == undefined ? "" : beneficiaryData.mobileNo,
            mobilePhoneCountryId     : beneficiaryData.mobileIDD == undefined ? 0 : parseInt(beneficiaryData.mobileIDD),
            smsNotification          : beneficiaryData.smsNotification == undefined ? "" : beneficiaryData.smsNotification,
            email                    : encodeURIComponent(beneficiaryData.email == undefined ? "" : beneficiaryData.email),
            emailNotification        : beneficiaryData.emailNotification == undefined ? "" : beneficiaryData.emailNotification,
            validateCreateBeneficiary: isCreateBeneficiary,
            bankNotes                : "",
            test                     : false
        }

        const url = 'main/beneficiary/validateinput'

        try {
            await ApiService.generateAuthClient();
            const response = await ApiService.customHeader(url, param, axiosHeader)
            // console.log("validate data " + JSON.stringify(response))
            validateInput = response.data;
            if(validateInput.status != '0412') {
                if(validateInput.status == '0403') {
                    validateInput.message = 'beneficiary-ws-error-bankBranch';
                    // 13 - Australia || 152 - New Zealand
                    if(beneficiaryData.homeCountryId == 13 || beneficiaryData.homeCountryId == 152) {
                        validateInput.inputField = "bsbCode";
                        validateInput.message = beneficiaryData.homeCountryId == 152 ? 'beneficiary-ws-error-bankCode' : 'beneficiary-ws-error-bsbCode';
                        validateInput.errMsg     = beneficiaryData.homeCountryId == 152 ? 'beneficiary-bank-code-error' : 'beneficiary-bsb-code-error'; // NZ = Bank code
                    }else{
                        validateInput.errMsg     = validateInput.message + "-desc";
                    }
                }else{
                    validateInput.errMsg     = validateInput.message + "-desc";
                }

                validateInput.invalid    = true;
                validateInput.errTitle   = validateInput.message;
                //validateInput.errMsg     = validateInput.message + "-desc";

                if(validateInput.message.indexOf('beneficiary-ws-error-') >= 0) {
                    if(validateInput.message == 'beneficiary-ws-error-bill-name') {
                        validateInput.inputField = 'beneficiaryName';
                    } else {
                        let errorKeyLength       = validateInput.message.length;
                        validateInput.inputField = validateInput.message.substring(21, errorKeyLength);
                    }
                }
            } else if(validateInput.status == '0412') {
                // console.log("result", validateInput.result)
                if(!validateInput.result.isValid && validateInput.result.daResultCode == 1751) {
                    validateInput.invalid    = true
                    validateInput.errTitle   = validateInput.result.message
                    validateInput.errMsg     = validateInput.result.message + "-desc"
                    validateInput.inputField = "bankAccountNo";
                }
            }

            return validateInput;
        } catch(e) {
            // console.log(e)
            // console.log("errroorr  " + JSON.stringify(e))
            validateInput.invalid  = true;
            validateInput.errTitle = "beneficiary-ws-general-error";
            validateInput.errMsg   = "beneficiary-ws-general-error-desc";
            return validateInput;
        }
    },

    modifyBeneficiary: async function(beneficiaryData) {
        let modifyBene = {invalid:false };
        ApiService.setHeader()

        let axiosHeader = {
            headers: {
                'Content-Type'                : 'application/json;charset=UTF-8',
                "Access-Control-Allow-Origin" : '*',
                "Authorization"               : `Bearer ${TokenService.getToken()}`,
                "WANDRE-OTP-UUID"             : ApiService.getFormData("uuid")
            }
        }

        let bankBranch = "";
        let pp         = (beneficiaryData.paymentPurposeId == -1)
                        ? beneficiaryData.paymentPurposeOther
                        : beneficiaryData.paymentPurpose;
        let idType     = (beneficiaryData.deliveryMethodId == 3
                            && (beneficiaryData.homeCountryId == 18 || beneficiaryData.homeCountryId == 98 || beneficiaryData.homeCountryId == 197))
                        ? beneficiaryData.idTypeSelect
                        : beneficiaryData.identificationType;

        const isPhilGov = parseInt(beneficiaryData.bankId) == 4520 || parseInt(beneficiaryData.bankId) == 4521 || parseInt(beneficiaryData.bankId) == 4522;
        const isWallet = (!isPhilGov && beneficiaryData.bankTypeId == 2 && beneficiaryData.deliveryMethodId == 1) ? true : false
        let accountNumber = beneficiaryData.bankAccountNo == undefined ? "" : beneficiaryData.bankAccountNo
        if(isWallet){
            if(beneficiaryData.homeCountryId == 167){ // exclude countryIDD for PH (DR-1438)
                accountNumber = beneficiaryData.walletNo == undefined ? "" : beneficiaryData.walletNo
            }else{
                accountNumber = beneficiaryData.walletNo == undefined ? "" : beneficiaryData.homeCountryIdd.substring(1) + beneficiaryData.walletNo
            }
        }

        // 1 - BANK TRANSFER
        if(beneficiaryData.deliveryMethodId == 1) {
            switch(beneficiaryData.homeCountryId) {
                case 13: // 13 - AUSTRALIA
                case 152: // 152 - NEW ZEALAND
                    bankBranch = beneficiaryData.bsbCode; break;
                case 238: // 238 - EUROPEAN UNION (EU)
                case 253: // 253 - AMERICA
                    bankBranch = beneficiaryData.swiftCode; break;
                // case 98: // 98 - INDIA
                //     bankBranch = beneficiaryData.ifscCode; break;
                case 221: // 221 - UNITED KINGDOM
                    bankBranch = beneficiaryData.sortCode; break;
                default:
                    bankBranch = beneficiaryData.bankBranch; break;
            }
        }

        // console.log("BillPayment: " + beneficiaryData.deliveryMethodId == 0)
        // console.log("BankTransfer: " + beneficiaryData.deliveryMethodId == 1)
        // console.log("Collection: " + beneficiaryData.deliveryMethodId == 3)

        const param = {
            destinationCountryId     : beneficiaryData.homeCountryId,
            originatingCountryId     : beneficiaryData.hostCountryId,
            transactionTypeId        : beneficiaryData.transactionTypeId,
            deliveryMethodId         : beneficiaryData.deliveryMethodId,
            bankAccountName          : encodeURIComponent(beneficiaryData.beneficiaryName == undefined ? "" : beneficiaryData.beneficiaryName),
            firstName                : encodeURIComponent(beneficiaryData.beneficiaryName == undefined ? "" : beneficiaryData.beneficiaryName),
            displayName              : encodeURIComponent(beneficiaryData.nickname == undefined ? "" : beneficiaryData.nickname),
            identificationType       : encodeURIComponent(idType == undefined ? "" : idType),
            identificationNo         : encodeURIComponent(beneficiaryData.identificationNo == undefined ? "" : beneficiaryData.identificationNo),
            beneficiaryTypeId        : beneficiaryData.beneficiaryTypeId,
            bankId                   : beneficiaryData.deliveryMethodId == 0 ? beneficiaryData.billCorporationId : beneficiaryData.bankId,
            bankBranch               : (bankBranch == undefined || bankBranch == "") ? "" : bankBranch,
            bankBranchId             : beneficiaryData.bankBranchId,
            iban                     : beneficiaryData.iban == undefined ? "" : beneficiaryData.iban,
            collectionAgentId        : beneficiaryData.collectionAgentId,
            collectionPointId        : beneficiaryData.collectionPointId,
            provinceId               : beneficiaryData.provinceId,
            cityId                   : beneficiaryData.cityId,
            address                  : encodeURIComponent(beneficiaryData.street == undefined ? "" : beneficiaryData.street),
            postCode                 : beneficiaryData.postcode == undefined ? "" : beneficiaryData.postcode,
            locatingNote             : encodeURIComponent(beneficiaryData.locatingNote == undefined ? "" : beneficiaryData.locatingNote),
            landmark                 : encodeURIComponent(beneficiaryData.landmark == undefined ? "" : beneficiaryData.landmark),
            bankAccountNo            : accountNumber,
            dateOfBirth              : encodeURIComponent(beneficiaryData.dateOfBirth == undefined ? "" : beneficiaryData.dateOfBirth),
            philGovMemberTypeId      : beneficiaryData.philGovMemberTypeId,
            referenceNo              : encodeURIComponent(beneficiaryData.refNo == undefined ? "" : beneficiaryData.refNo),
            audAbn                   : beneficiaryData.audAbn == undefined ? "" : beneficiaryData.audAbn,
            audAcn                   : beneficiaryData.audAcn == undefined ? "" : beneficiaryData.audAcn,
            nzbn                     : beneficiaryData.nzbn == undefined ? "" : beneficiaryData.nzbn,
            beneficiaryCountryId     : beneficiaryData.beneficiaryCountryId == undefined ? 0 : parseInt(beneficiaryData.beneficiaryCountryId),
            beneficiaryTownCity      : encodeURIComponent(beneficiaryData.beneficiaryTownCity == undefined ? "" : beneficiaryData.beneficiaryTownCity),
            paymentPurpose           : encodeURIComponent(pp == undefined ? "" : pp),
            homePhone                : beneficiaryData.homeNo == undefined ? "" : beneficiaryData.homeNo,
            homePhoneCountryId       : beneficiaryData.homeIDD == undefined ? "" : beneficiaryData.homeIDD,
            mobilePhone              : beneficiaryData.mobileNo == undefined ? "" : beneficiaryData.mobileNo,
            mobilePhoneCountryId     : beneficiaryData.mobileIDD == undefined ? "" : beneficiaryData.mobileIDD,
            smsNotification          : beneficiaryData.smsNotification == undefined ? "" : beneficiaryData.smsNotification,
            email                    : encodeURIComponent(beneficiaryData.email == undefined ? "" : beneficiaryData.email),
            emailNotification        : beneficiaryData.emailNotification == undefined ? "" : beneficiaryData.emailNotification,
            validateCreateBeneficiary: false,
            bankNotes                : "",
            test                     : false
        }

        const url = 'main/beneficiary/modify/' + beneficiaryData.beneficiaryId

        try {
            await ApiService.generateAuthClient();
            const response = await ApiService.customHeader(url, param, axiosHeader)
            // console.log(response)
            modifyBene = response.data

            return modifyBene
        } catch(e) {
            // console.log(e)
            // console.log("modifyBeneError: " + JSON.stringify(e))
            modifyBene.invalid = true;
            if(e.response.data.status == '90008') { // Access token has expired
                modifyBene.message = "otp-invalid-text-8"
            }
            return modifyBene
        }
    },

    deleteBeneficiary: async function(beneficiaryId) {
        let deleteBene = {invalid:false };
        const url = 'main/beneficiary/delete/' + beneficiaryId

        try {
            await ApiService.generateAuthClient();
            const response = await ApiService.put(url, {})
            // console.log("deleteBene: " + JSON.stringify(response))
            deleteBene = response.data
            if(deleteBene.status != '0409') {
                deleteBene.invalid  = true
                deleteBene.errTitle = deleteBene.message
                deleteBene.errMsg   = deleteBene.message + "-desc"
            }
            return deleteBene
        } catch(e) {
            // console.log(e)
            // console.log("deleteBeneError: " + JSON.stringify(e))
            deleteBene.invalid  = true;
            deleteBene.errTitle = "beneficiary-ws-general-error";
            deleteBene.errMsg   = "beneficiary-ws-general-error-desc";
            return deleteBene
        }
    },

    getServiceId: async function( bankId, bankBranchId, homeCountryId, deliveryMethodId) {
        const url = 'main/deliverytime/service'
        try {
            const params = {
                raId             : process.env.VUE_APP_RETAIL_AGENT_ID,
                retailBranchId   : store.state.misc.appBranchId,
                countryId        : homeCountryId,
                bankId           : bankId,
                bankBranchId     : bankBranchId,
                deliveryMethodId : deliveryMethodId
            }
            await ApiService.generateAuthClient();
            const response = await ApiService.get(url, {params})

            return ApiService.validateResponse(response, 'WN00432');
        } catch (e) {
            console.log(e)
            if (e instanceof GenericError) {
                throw e
            }
        }
    },
}

export default BeneficiaryService
